{% block ap_pdf_check %}
    <sw-page class="ap-pdf-check">
        <template #content>
            <sw-card-view>
                <div class="sw-card">
                    <div class="sw-card__title">{{ $t('ap-pdfs.content.informationPDFText') }}</div>
                    <div class="sw-card__content">
                        <div class="product-basic-form">
                            <div class="sw-container"
                                 style="grid-template-columns: 1fr 1fr 1fr; gap: 0px 30px; place-items: stretch;">
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            <label
                                                    class="is--required">{{ $t('ap-pdfs.content.customersNumberText') }}</label>
                                        </div>
                                        <div class="sw-block-field__block">
                                            <input type="text" v-model="addressNumber">
                                        </div>
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            <label
                                                    class="is--required">{{ $t('ap-pdfs.content.invoiceNumberText') }}</label>
                                        </div>
                                        <div class="sw-block-field__block">
                                            <input type="text" v-model="invoiceNumber">
                                        </div>
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            &nbsp;
                                        </div>
                                        <sw-button-process variant="primary" :isLoading="isLoading"
                                                           :processSuccess="processSuccess"
                                                           @process-finish="apSaveFinish" @click="apOnClickPDFFetch">
                                            {{ $t('ap-pdfs.content.getPDFText') }}
                                        </sw-button-process>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product-basic-form">
                            <div class="sw-container"
                                 style="grid-template-columns: 1fr 1fr 1fr; gap: 0px 30px; place-items: stretch;">
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            <label>{{ $t('ap-pdfs.content.userPrintId') }}</label>
                                        </div>
                                        <div class="sw-block-field__block">
                                            <input type="text" v-model="druckUserID">
                                        </div>
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            <label>{{ $t('ap-pdfs.content.userPrintTemplate') }}</label>
                                        </div>
                                        <div class="sw-block-field__block">
                                            <input type="text" v-model="druckVorlage">
                                        </div>
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div class="sw-field__label" style="height: 40px;">
                                        <label></label>
                                    </div>
                                    <div class="sw-block-field__block">
                                        <sw-checkbox-field
                                                v-model:value="useCurrentPdf"
                                                class="sw-customer-base-info__checkbox-field"
                                                :label="$tc('ap-pdfs.content.placeholderCurrentPdf')"
                                                size="small"
                                                :value=true
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sw-container">
                            <sw-email-field
                                    required
                                    :label="$tc('ap-pdfs.content.labelEmail')"
                                    v-model:value="invoiceEmailAddress">
                            </sw-email-field>
                        </div>
                        <div class="sw-container">
                            <sw-text-field
                                    required
                                    :label="$tc('ap-pdfs.content.labelEmailSubject')"
                                    v-model:value="invoiceEmailSubject">
                            </sw-text-field>
                        </div>
                        <div class="sw-container">
                            <sw-textarea-field
                                    required
                                    :label="$tc('ap-pdfs.content.labelEmailContent')"
                                    v-model:value="invoiceEmailText">
                            </sw-textarea-field>
                        </div>
                        <div class="sw-container"
                             style="grid-template-columns: 1fr 1fr 1fr; gap: 0px 30px; place-items: stretch;">
                            <div class="sw-inherit-wrapper">
                                <div
                                        class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                    <sw-button-process variant="primary" :isLoading="isLoading"
                                                       :processSuccess="processSuccess"
                                                       @process-finish="apSaveFinish" @click="apOnClickPDFSend">
                                        {{ $t('ap-pdfs.content.sendPDFText') }}
                                    </sw-button-process>
                                </div>
                            </div>
                        </div>
                        <div class="sw-data-grid" v-if="showResultsContainer" style="border: 1px solid #d1d9e0;">
                            <div class="sw-data-grid__wrapper">
                                <table class="sw-data-grid__table" v-if="isError" ref="table">
                                    <tbody class="sw-data-grid__body">
                                    <template v-for="valueMsg in errorMessage">
                                        <tr class="sw-data-grid__row">
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection">
                                                <div class="sw-data-grid__cell-content"
                                                     style="white-space: unset;color: red;">
                                                    {{ $t(valueMsg) }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </sw-card-view>
        </template>
    </sw-page>
{% endblock %}
